import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../hooks';

const Gnb: React.FC = () => {
    const [toogleCheck, setToogleCheck] = useState<number>(0);
    const memId = useAppSelector(state => state.auth.memId);
    const memName = useAppSelector(state => state.auth.memName);

    const handleClick = () => {
        var wSize3 = $(window).width();
        if( toogleCheck === 0) {
            $("#warp").stop().animate({"margin-left" : "-220px","width" : wSize3});
            setToogleCheck(1)
        } else if( toogleCheck === 1) {
            $("#warp").stop().animate({"margin-left" : "0px","width" : "100%"});
            setToogleCheck(0)
        }
    }

    useEffect(() => {
        $("#gnb nav >ul >li >a").on("mouseenter focus", function () {
            $(this).parent().siblings().find(">div").slideUp({duration: 200});
            $(this).siblings().stop().delay(70).slideDown({duration: 100});
        });
        $("#gnb nav >ul >li >div").on("mouseleave", function() {
            $("#gnb nav >ul >li > div").stop().slideUp({duration: 200})
        });
    }, [])

    const handleUrl = (uri: string) => {
        if (null !== memId && "" !== memId) {
            let javaexcept = "ok";
            let encJoinID = encodeURIComponent(memId);
            let aspLoginUrl = process.env.REACT_APP_API_URL + "/member/member_Login_Proc.asp?" + "JoinID=" + memName
            + "&JoinKey=" + encJoinID + "&LoginRePath=" + uri + "&except=" + javaexcept;

            window.location.href = aspLoginUrl;
        } else {
            window.location.href = process.env.REACT_APP_API_URL + uri;
        }
	}

    return (
        <div id="gnb">
            <div className='clearfix'>
                <h1>
                    <a href="#" onClick={() => handleUrl("/default.asp")}>
                        <span className="pc"><img src="/images/common/gnb_logo.png" alt="교보생명 교보헬스케어서비스" /></span>
						<span className="mobile"><img src="/images/common/gnb_logo_m.png" alt="교보생명 교보헬스케어서비스" /></span>	
						<span className="tablet"><img src="/images/common/gnb_logo_t.png" alt="교보생명 교보헬스케어서비스" /></span>
                    </a>
                </h1>
                <button type="button" className="mobile" onClick={handleClick}>모바일용 메뉴</button>
                <nav>
                    <ul className="clearfix">
                        <li>
                            <a href="#" onClick={() => handleUrl("/service/service_healthcare.asp")}><span>서비스안내</span></a>
                            <div className="service">
                                <ul>
                                    <li><a href="#" onClick={() => handleUrl("/service/service_healthcare.asp")}>헬스케어서비스 소개</a></li>
                                    <li><a href="#" onClick={() => handleUrl("/service/service_faq.asp")}>자주 묻는 질문</a></li>
                                    <li><a href="#" onClick={() => handleUrl("/service/service_afterlist.asp")}>서비스 체험수기</a></li>
                                </ul>
                            </div>
						</li>
                        <li>
                            <a href="#" onClick={() => handleUrl("/util/util_CounselUp.asp")}><span>서비스 이용</span></a>
                            <div className="util">
                                <ul>
                                    <li><a href="#" onClick={() => handleUrl("/util/util_CounselUp.asp")}>평상시 건강관리</a></li>
                                    <li><a href="#" onClick={() => handleUrl("/util/util_VisitingCare.asp")}>가족 건강관리</a></li>
                                    <li><a href="#" onClick={() => handleUrl("/util/util_DoctorInfo.asp")}>일반 치료지원</a></li>
                                    <li><a href="#" onClick={() => handleUrl("/util/util_NurseWith.asp")}>중대질환 치료지원</a></li>
                                    <li><a href="#" onClick={() => handleUrl("/util/util_healthPDS_main.asp")}>프리미어 헬스케어서비스</a></li>
                                </ul>
                            </div>
                        </li>
                        <li>
                            <a href="#" onClick={() => handleUrl("/check/check_HealthUp.asp")}><span>건강체크</span></a>
                            <div className="check">
                                <ul>
                                    <li><a href="#" onClick={() => handleUrl("/check/check_HealthUp.asp")}>헬스업 프로그램</a></li>
                                    <li><a href="#" onClick={() => handleUrl("/check/check_healthGraph_Weight.asp")}>건강그래프</a></li>
                                    <li><a href="#" onClick={() => handleUrl("/coaching/coaching_CoachingCall_main.asp")}>1:1 코칭콜</a></li>
                                    <li><a href="#" onClick={() => handleUrl("/check/check_healthPDS_main.asp")}>건강증진 프로그램</a></li>
                                </ul>
                            </div>
                        </li>
                        <li>
                            <a href="#" onClick={() => handleUrl("/reference/reference_info_main.asp")}><span>건강자료실</span></a>
                            <div className="reference">
                                <ul>
                                    <li><a href="#" onClick={() => handleUrl("/reference/reference_info_main.asp")}>한 눈에 보는 건강정보</a></li>
                                    <li><a href="#" onClick={() => handleUrl("/reference/reference_dental_list.asp")}>치아건강</a></li>
                                    <li><a href="#" onClick={() => handleUrl("/reference/reference_expert_list.asp")}>전문의에게 듣는 건강상식</a></li>
                                    <li><a href="#" onClick={() => handleUrl("/reference/reference_news_list.asp")}>건강뉴스</a></li>
                                    <li><a href="#" onClick={() => handleUrl("/reference/reference_newsletter_list.asp")}>건강뉴스레터</a></li>
                                </ul>
                            </div>
                        </li>
                        <li className="last">
						    <a href="/column/columnList"><span>토닥토닥마음케어</span></a>
                            <div className="therapy">
                                <ul>
                                    <li><Link to="/column/columnList">전문심리칼럼</Link></li>
                                    <li><Link to="/psychlgclCheck/main">무료심리검사</Link></li>
                                    <li><Link to="/healingContent/main">힐링컨텐츠</Link></li>
                                    <li><Link to="/psychgclCounsel/counselMain">제휴심리상담센터</Link></li>
                                </ul>
                            </div>
					    </li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}

export default Gnb;